
export class my360meshall {
    public unit_len = 80;
    public constructor() {

    }
    public temp1 = new Array<BABYLON.Vector3>();
    public temp2 = new Array<BABYLON.Vector3>();
    public temp3 = new Array<BABYLON.Vector3>();
    public temp4 = new Array<BABYLON.Vector3>();
    test = false;


    public top1 = new Array<BABYLON.Vector3>();
    public bot1 = new Array<BABYLON.Vector3>();

    my_create(scene: BABYLON.Scene, mat: BABYLON.Material, name: string) {

        let l = new Array<Array<BABYLON.Vector3>>();
        let n_l = new Array<Array<BABYLON.Vector3>>();
        let uv_l = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p(l, n_l, uv_l, 0, 135, ((2048 + 4) * 2 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        let my_ver = new Array<BABYLON.Vector3>();
        let my_n = new Array<BABYLON.Vector3>();
        let my_uv = new Array<BABYLON.Vector2>();
  
        for (let i = 0; i < l.length - 1; i++) {
           this.gen_tria0(l[i], n_l[i], uv_l[i], l[i + 1], n_l[i + 1], uv_l[i + 1], my_ver, my_n, my_uv);
        }
  
        let l1 = new Array<Array<BABYLON.Vector3>>();
        let n_l1 = new Array<Array<BABYLON.Vector3>>();
        let uv_l1 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p(l1, n_l1, uv_l1, 0, 225, ((1024 * 2 + 4) * 1 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
  
        for (let i = 0; i < l1.length - 1; i++) {
           this.gen_tria0(l1[i], n_l1[i], uv_l1[i], l1[i + 1], n_l1[i + 1], uv_l1[i + 1], my_ver, my_n, my_uv);
        }
  
  
        let l2 = new Array<Array<BABYLON.Vector3>>();
        let n_l2 = new Array<Array<BABYLON.Vector3>>();
        let uv_l2 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p(l2, n_l2, uv_l2, 0, 45, ((1024 * 2 + 4) * 0 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < n_l2.length - 1; i++) {
           this.gen_tria0(l2[i], n_l2[i], uv_l2[i], l2[i + 1], n_l2[i + 1], uv_l2[i + 1], my_ver, my_n, my_uv);
        }
  
        let l4 = new Array<Array<BABYLON.Vector3>>();
        let n_l4 = new Array<Array<BABYLON.Vector3>>();
        let uv_l4 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p(l4, n_l4, uv_l4, 0, 315, ((1024 * 2 + 4) * 3 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l4.length - 1; i++) {
           this.gen_tria0(l4[i], n_l4[i], uv_l4[i], l4[i + 1], n_l4[i + 1], uv_l4[i + 1], my_ver, my_n, my_uv);
        }
  
  
        let l5 = new Array<Array<BABYLON.Vector3>>();
        let n_l5 = new Array<Array<BABYLON.Vector3>>();
        let uv_l5 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p1(l5, n_l5, uv_l5, 0, 135, ((1024 * 2 + 4) * 4 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l5.length - 1; i++) {
           this.gen_tria_sp0(l5[i], n_l5[i], uv_l5[i], l5[i + 1], n_l5[i + 1], uv_l5[i + 1], my_ver, my_n, my_uv);
        }
  
        let l6 = new Array<Array<BABYLON.Vector3>>();
        let n_l6 = new Array<Array<BABYLON.Vector3>>();
        let uv_l6 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p2(l6, n_l6, uv_l6, 0, 135, ((1024 * 2 + 4) * 5 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l6.length - 1; i++) {
           this.gen_tria_sp(l6[i], n_l6[i], uv_l6[i], l6[i + 1], n_l6[i + 1], uv_l6[i + 1], my_ver, my_n, my_uv);
        }
  
  
        let l7 = new Array<Array<BABYLON.Vector3>>();
        let n_l7 = new Array<Array<BABYLON.Vector3>>();
        let uv_l7 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p1(l7, n_l7, uv_l7, 0, 225, ((1024 * 2 + 4) * 4 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l7.length - 1; i++) {
           this.gen_tria_sp0(l7[i], n_l7[i], uv_l7[i], l7[i + 1], n_l7[i + 1], uv_l7[i + 1], my_ver, my_n, my_uv);
        }
  
        let l8 = new Array<Array<BABYLON.Vector3>>();
        let n_l8 = new Array<Array<BABYLON.Vector3>>();
        let uv_l8 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p2(l8, n_l8, uv_l8, 0, 225, ((1024 * 2 + 4) * 5 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l6.length - 1; i++) {
           this.gen_tria_sp(l8[i], n_l8[i], uv_l8[i], l8[i + 1], n_l8[i + 1], uv_l8[i + 1], my_ver, my_n, my_uv);
        }
  
        let l9 = new Array<Array<BABYLON.Vector3>>();
        let n_l9 = new Array<Array<BABYLON.Vector3>>();
        let uv_l9 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p1(l9, n_l9, uv_l9, 0, 45, ((1024 * 2 + 4) * 4 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l9.length - 1; i++) {
           this.gen_tria_sp0(l9[i], n_l9[i], uv_l9[i], l9[i + 1], n_l9[i + 1], uv_l9[i + 1], my_ver, my_n, my_uv);
        }
  
        let l10 = new Array<Array<BABYLON.Vector3>>();
        let n_l10 = new Array<Array<BABYLON.Vector3>>();
        let uv_l10 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p2(l10, n_l10, uv_l10, 0, 45, ((1024 * 2 + 4) * 5 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l10.length - 1; i++) {
           this.gen_tria_sp(l10[i], n_l10[i], uv_l10[i], l10[i + 1], n_l10[i + 1], uv_l10[i + 1], my_ver, my_n, my_uv);
        }
  
        let l11 = new Array<Array<BABYLON.Vector3>>();
        let n_l11 = new Array<Array<BABYLON.Vector3>>();
        let uv_l11 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p1(l11, n_l11, uv_l11, 0, 315, ((1024 * 2 + 4) * 4 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < l11.length - 1; i++) {
           this.gen_tria_sp0(l11[i], n_l11[i], uv_l11[i], l11[i + 1], n_l11[i + 1], uv_l11[i + 1], my_ver, my_n, my_uv);
        }
        let l12 = new Array<Array<BABYLON.Vector3>>();
        let n_l12 = new Array<Array<BABYLON.Vector3>>();
        let uv_l12 = new Array<Array<BABYLON.Vector2>>();
        this.cacu_p2(l12, n_l12, uv_l12, 0, 315, ((1024 * 2 + 4) * 5 + 2) / (8 * 1024 * 2), 1024 * 2 / (8 * 1024 * 2));
  
        for (let i = 0; i < n_l12.length - 1; i++) {
           this.gen_tria_sp(l12[i], n_l12[i], uv_l12[i], l12[i + 1], n_l12[i + 1], uv_l12[i + 1], my_ver, my_n, my_uv);
        }
        this.create_test(scene, my_ver, my_n, name, my_uv, mat);
     }

    create_test(scene: BABYLON.Scene, my_ver: Array<BABYLON.Vector3>, my_n: Array<BABYLON.Vector3>, name: string, my_uv: Array<BABYLON.Vector2>, mat: BABYLON.Material) {
        var customMesh = new BABYLON.Mesh(name, scene);

        var positions = new Array<number>();// [0,0,0,60,0,0,60,0,60,0,0,60];
        var indices = new Array<number>();// [0, 1, 2, 0,2,3];
        var uv = new Array<number>();//[5,5, 5,0, 0,0, 0,5, 5,5, 0,0];

        for (let i = 0; i < my_ver.length; i++) {
            positions.push(my_ver[i].x);
            positions.push(my_ver[i].y);
            positions.push(my_ver[i].z);
            indices.push(i);
            uv.push(my_uv[i].x);
            uv.push(my_uv[i].y);

        }

        var vertexData = new BABYLON.VertexData();

        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.uvs = uv;
        vertexData.applyToMesh(customMesh);
        customMesh.material = mat;
        customMesh.position = new BABYLON.Vector3(-2200, 190.20770263671875, 430);//(0,-130,90);
        customMesh.rotation.y += Math.PI;
        customMesh.rotation.z += Math.PI;
    }

    cacu_side(pp_l: Array<BABYLON.Vector3>, w_start: number, j_start: number) {
        let w_len = 30;
        let h_len = 30;
        let wd = 0;
        let jd = 0;
  
        let now_w = 0;
        let now_h = 0;
  
        let temp = 0;
        for (let h = 0; h <= h_len;)//for (int h=50; h<=h_len; )
        {
           let p_l: Array<BABYLON.Vector3> = new Array();
           let n_l: Array<BABYLON.Vector3> = new Array();
           let uv_l: Array<BABYLON.Vector2> = new Array();
  
           for (let w = 0; w <= 0;) {
              if (w <= w_len / 2) {
                 now_w = w_len / 2.0 - w;
                 jd = Math.atan(now_w / (w_len / 2.0)) * (180 / Math.PI);
                 jd = 45 - jd;
                 jd += j_start;
                 if (jd > 360)
                    jd = jd - 360;
              }
              else {
                 now_w = -w_len / 2.0 + w;
                 jd = Math.atan(now_w / (w_len / 2.0)) * (180 / Math.PI);
                 jd = 45 + jd;
                 jd += j_start;
                 if (jd > 360)
                    jd = jd - 360;
              }
  
              if (h <= h_len / 2) {
                 now_h = h_len / 2.0 - h;
                 temp = Math.sqrt(now_w * now_w + w_len * w_len / 4.0);
  
                 wd = Math.atan(now_h / temp) * (180 / Math.PI);
                 wd = 90 - wd;
              }
              else {
                 now_h = -h_len / 2.0 + h;
                 temp = Math.sqrt(now_w * now_w + w_len * w_len / 4.0);
  
                 wd = Math.atan(now_h / temp) * (180 / Math.PI);
                 wd = 90 + wd;
              }
              let v = new BABYLON.Vector3((jd - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
              pp_l.push(v);
              w += 1;
           }
           h += 1;
        }
     }

     cacu_p(p_l_L: Array<Array<BABYLON.Vector3>>, n_l_L: Array<Array<BABYLON.Vector3>>, uv_l_L: Array<Array<BABYLON.Vector2>>, w_start: number, j_start: number, u_start: number, u_len: number) {
        let w_len = 30;
        let h_len = 30;
        let wd = 0;
        let jd = 0;
  
        let now_w = 0;
        let now_h = 0;
  
        let temp = 0;
        for (let h = 0; h <= h_len;)//for (int h=50; h<=h_len; )
        {
           let p_l: Array<BABYLON.Vector3> = new Array();
           let n_l: Array<BABYLON.Vector3> = new Array();
           let uv_l: Array<BABYLON.Vector2> = new Array();
  
           for (let w = 0; w <= w_len;) {
              if (w <= w_len / 2) {
                 now_w = w_len / 2.0 - w;
                 jd = Math.atan(now_w / (w_len / 2.0)) * (180 / Math.PI);
                 jd = 45 - jd;
                 jd += j_start;
                 if (jd > 360)
                    jd = jd - 360;
              }
              else {
                 now_w = -w_len / 2.0 + w;
                 jd = Math.atan(now_w / (w_len / 2.0)) * (180 / Math.PI);
                 jd = 45 + jd;
                 jd += j_start;
                 if (jd > 360)
                    jd = jd - 360;
              }
  
              if (h <= h_len / 2) {
                 now_h = h_len / 2.0 - h;
                 temp = Math.sqrt(now_w * now_w + w_len * w_len / 4.0);
  
                 wd = Math.atan(now_h / temp) * (180 / Math.PI);
                 wd = 90 - wd;
  
              }
              else {
                 now_h = -h_len / 2.0 + h;
                 temp = Math.sqrt(now_w * now_w + w_len * w_len / 4.0);
  
                 wd = Math.atan(now_h / temp) * (180 / Math.PI);
                 wd = 90 + wd;
              }
  
              let v = new BABYLON.Vector3((jd - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
              let uv = new BABYLON.Vector2(u_start + (w / (w_len * 1.0)) * u_len, h / (h_len * 1.0));
  
              p_l.push(v);
              uv_l.push(uv);
              let n = new BABYLON.Vector3(0, 0, -1);
              n_l.push(n);
  
              if (jd == 360) {
                 let v1 = new BABYLON.Vector3((0 - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
                 p_l.push(v1);
                 uv_l.push(uv);
  
                 n_l.push(n);
              }
  
              w += 1;
           }
  
           p_l_L.push(p_l);
           n_l_L.push(n_l);
           uv_l_L.push(uv_l);
           h += 1;
        }
     }
  
     cacu_p1(p_l_L: Array<Array<BABYLON.Vector3>>, n_l_L: Array<Array<BABYLON.Vector3>>, uv_l_L: Array<Array<BABYLON.Vector2>>, w_start: number, j_start: number, u_start: number, u_len: number)//(List< List<Vector3> >p_l_L,List< List<Vector3> > n_l_L,List< List<Vector2> >uv_l_L,float w_start,float j_start)
     {
        let w_len = 30;
        let h_len = 30;
        let wd = 0;
        let jd = 0;
  
        let now_w = 0;
        let now_h = 0;
  
        let temp = 0;
        for (let h = 0; h < h_len / 2;) {
           let p_l: Array<BABYLON.Vector3> = new Array<BABYLON.Vector3>();
           let n_l: Array<BABYLON.Vector3> = new Array<BABYLON.Vector3>();
           let uv_l: Array<BABYLON.Vector2> = new Array<BABYLON.Vector2>();
  
  
           for (let w = 0 + h; w <= w_len - h;) {
              if (w <= w_len / 2) {
                 now_w = w_len / 2.0 - w;
                 jd = Math.atan(now_w / (w_len / 2.0 - h)) * (180 / Math.PI);
                 jd = 45 - jd;
                 jd += j_start;
                 if (jd < 0)
                    jd += 360;
                 else if (jd > 360)
                    jd -= 360;
              }
              else {
                 now_w = -w_len / 2.0 + w;
                 jd = Math.atan(now_w / (w_len / 2.0 - h)) * (180 / Math.PI);
                 jd = 45 + jd;
                 jd += j_start;
  
                 if (jd < 0)
                    jd += 360;
                 else if (jd > 360)
                    jd -= 360;
              }
  
              if (h <= h_len / 2) {
                 now_h = h_len / 2.0 - h;
                 temp = Math.sqrt(now_w * now_w + now_h * now_h);
  
                 wd = Math.atan(h_len / (2 * temp)) * (180 / Math.PI);
                 wd = 90 - wd;
              }
  
              let v = new BABYLON.Vector3((jd - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
  
              if (h == (h_len / 2 - 1))
                 v.y = 0 - this.unit_len / 2;
              let uv = new BABYLON.Vector2(u_start + (w / (w_len * 1.0)) * u_len, 1 - h / (h_len * 1.0));
              if (j_start == 225) {
                 uv = new BABYLON.Vector2(u_start + (1 - h / (h_len * 1.0)) * u_len, (1 - w / (w_len * 1.0)) * 1);
              }
              else if (j_start == 45) {
                 uv = new BABYLON.Vector2(u_start + (h / (h_len * 1.0)) * u_len, (w / (w_len * 1.0)) * 1);
              }
              else if (j_start == 315) {
                 uv = new BABYLON.Vector2(u_start + (1 - w / (w_len * 1.0)) * u_len, h / (h_len * 1.0));
              }
              p_l.push(v);
              uv_l.push(uv);
              let n = new BABYLON.Vector3(0, 0, -1);
              n_l.push(n);
  
  
              if (jd == 360) {
                 v = new BABYLON.Vector3((0 - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
                 if (h == (h_len / 2 - 1))
                    v.y = 0 - this.unit_len / 2;
                 p_l.push(v);
                 uv_l.push(uv);
                 n_l.push(n);
              }
              w += 1;
           }
           p_l_L.push(p_l);
           n_l_L.push(n_l);
           uv_l_L.push(uv_l);
           h += 1;
        }
     }
  
     cacu_p2(p_l_L: Array<Array<BABYLON.Vector3>>, n_l_L: Array<Array<BABYLON.Vector3>>, uv_l_L: Array<Array<BABYLON.Vector2>>, w_start: number, j_start: number, u_start: number, u_len: number)//(List< List<Vector3> >p_l_L,List< List<Vector3> > n_l_L,List< List<Vector2> >uv_l_L,float w_start,float j_start)
     {
        let w_len = 30;
        let h_len = 30;
        let wd = 0;
        let jd = 0;
  
        let now_w = 0;
        let now_h = 0;
  
        let temp = 0;
        for (let h = 0; h < h_len / 2;) {
           let p_l: Array<BABYLON.Vector3> = new Array<BABYLON.Vector3>();
           let n_l: Array<BABYLON.Vector3> = new Array<BABYLON.Vector3>();
           let uv_l: Array<BABYLON.Vector2> = new Array<BABYLON.Vector2>();
  
  
           for (let w = 0 + h; w <= w_len - h;) {
              if (w <= w_len / 2) {
                 now_w = w_len / 2.0 - w;
                 jd = Math.atan(now_w / (w_len / 2.0 - h)) * (180 / Math.PI);
                 jd = 45 - jd;
                 jd += j_start;
                 if (jd < 0)
                    jd += 360;
                 else if (jd > 360)
                    jd -= 360;
              }
              else {
                 now_w = -w_len / 2.0 + w;
                 jd = Math.atan(now_w / (w_len / 2.0 - h)) * (180 / Math.PI);
                 jd = 45 + jd;
                 jd += j_start;
                 if (jd < 0)
                    jd += 360;
                 else if (jd > 360)
                    jd -= 360;
              }
  
              if (h <= h_len / 2) {
                 now_h = h_len / 2.0 - h;
                 temp = Math.sqrt(now_w * now_w + now_h * now_h);
  
                 wd = Math.atan(h_len / (2 * temp)) * (180 / Math.PI);
                 wd = 90 + wd;
  
              }
  
              let v = new BABYLON.Vector3((jd - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);
              if (h == (h_len / 2 - 1))
                 v.y = this.unit_len / 2;
              let uv = new BABYLON.Vector2(u_start + (w / (w_len * 1.0)) * u_len, h / (h_len * 1.0));
              if (j_start == 225) {
                 uv = new BABYLON.Vector2(u_start + (1 - h / (h_len * 1.0)) * u_len, (w / (w_len * 1.0)) * 1);
              }
              else if (j_start == 45) {
                 uv = new BABYLON.Vector2(u_start + (h / (h_len * 1.0)) * u_len, (1 - w / (w_len * 1.0)) * 1);
              }
              else if (j_start == 315) {
                 uv = new BABYLON.Vector2(u_start + (1 - w / (w_len * 1.0)) * u_len, 1 - h / (h_len * 1.0));
              }
              p_l.push(v);
              uv_l.push(uv);
              let n = new BABYLON.Vector3(0, 0, -1);
              n_l.push(n);
              if (jd == 360) {
                 v = new BABYLON.Vector3((0 - 180) / 360.0 * this.unit_len, (wd - 90) / 180.0 * this.unit_len, 0);;
                 if (h == (h_len / 2 - 1))
                    v.y = this.unit_len / 2;
                 p_l.push(v);
                 uv_l.push(uv);
                 n_l.push(n);
              }
              w += 1;
           }
           p_l_L.push(p_l);
           n_l_L.push(n_l);
           uv_l_L.push(uv_l);
  
           h += 1;
        }
     }
  
  
  
  
     gen_tria0(s_l: Array<BABYLON.Vector3>, s_n: Array<BABYLON.Vector3>, s_uv: Array<BABYLON.Vector2>, s_l1: Array<BABYLON.Vector3>, s_n1: Array<BABYLON.Vector3>, s_uv1: Array<BABYLON.Vector2>, my_ver: Array<BABYLON.Vector3>, my_n: Array<BABYLON.Vector3>, my_uv: Array<BABYLON.Vector2>) {
        for (let i = 0; i < s_l.length - 1; i++) {
           {
              my_ver.push(s_l1[i]);
  
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l[i]);
  
              my_ver.push(s_l1[i + 1]);
              my_ver.push(s_l[i + 1]);
  
              my_ver.push(s_l1[i]);
  
              my_n.push(s_n1[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n[i]);
  
  
              my_n.push(s_n1[i + 1]);
              my_n.push(s_n[i + 1]);
  
              my_n.push(s_n1[i]);
  
              my_uv.push(s_uv1[i]);
              my_uv.push(s_uv[i + 1]);
              my_uv.push(s_uv[i]);
  
  
              my_uv.push(s_uv1[i + 1]);
              my_uv.push(s_uv[i + 1]);
              my_uv.push(s_uv1[i]);
  
           }
  
  
        }
     }
  
     gen_tria(s_l: Array<BABYLON.Vector3>, s_n: Array<BABYLON.Vector3>, s_uv: Array<BABYLON.Vector2>, s_l1: Array<BABYLON.Vector3>, s_n1: Array<BABYLON.Vector3>, s_uv1: Array<BABYLON.Vector2>, my_ver: Array<BABYLON.Vector3>, my_n: Array<BABYLON.Vector3>, my_uv: Array<BABYLON.Vector2>) {
        for (let i = 0; i < s_l.length - 1; i++) {
           {
  
              my_ver.push(s_l[i]);
              my_ver.push(s_l[i + 1]);
  
              my_ver.push(s_l1[i]);
  
              my_ver.push(s_l1[i]);
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l1[i + 1]);
  
              my_n.push(s_n[i]);
              my_n.push(s_n[i + 1]);
  
              my_n.push(s_n1[i]);
  
              my_n.push(s_n1[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n1[i + 1]);
  
  
              my_uv.push(s_uv[i]);
              my_uv.push(s_uv[i + 1]);
  
              my_uv.push(s_uv1[i]);
  
              my_uv.push(s_uv1[i]);
              my_uv.push(s_uv[i + 1]);
  
              my_uv.push(s_uv1[i + 1]);
           }
  
  
        }
     }
  
     gen_tria_sp0(s_l: Array<BABYLON.Vector3>, s_n: Array<BABYLON.Vector3>, s_uv: Array<BABYLON.Vector2>, s_l1: Array<BABYLON.Vector3>, s_n1: Array<BABYLON.Vector3>, s_uv1: Array<BABYLON.Vector2>, my_ver: Array<BABYLON.Vector3>, my_n: Array<BABYLON.Vector3>, my_uv: Array<BABYLON.Vector2>) {
        let c = (s_l.length - 3) / 2 + 1;
        if (s_l.length % 2 == 0) {
           c = (s_l.length - 3) / 2;
        }
  
        for (let i = 0; i < c; i++) {
           //			if (i != 0 && i != s_l.Count - 2) 
           if (i != (s_l.length - 3) / 2) {
              my_ver.push(s_l[i]);
              my_ver.push(s_l[i + 1]);
  
              my_ver.push(s_l1[i]);
  
              my_ver.push(s_l1[i]);
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l1[i + 1]);
  
  
              my_n.push(s_n[i]);
              my_n.push(s_n[i + 1]);
  
  
              my_n.push(s_n1[i]);
              my_n.push(s_n1[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n1[i + 1]);
  
  
              my_uv.push(s_uv[i]);
              my_uv.push(s_uv[i + 1]);
              my_uv.push(s_uv1[i]);
  
  
              my_uv.push(s_uv1[i]);
              my_uv.push(s_uv[i + 1]);
              my_uv.push(s_uv1[i + 1]);
  
  
           }
           else {
              my_ver.push(s_l[i]);
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l1[i]);
              my_n.push(s_n[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n1[i]);
              my_uv.push(s_uv[i]);
              my_uv.push(s_uv[i + 1]);
              my_uv.push(s_uv1[i]);
           }
  
  
        }
        let k = 0, l = 0;
        for (let i = 0; i < c; i++) {
           k = s_l.length - i - 1;
           l = s_l1.length - i - 1;
           if (i != (s_l.length - 3) / 2) {
              my_ver.push(s_l1[l]);
              my_ver.push(s_l[k - 1]);
              my_ver.push(s_l[k]);
  
  
              my_ver.push(s_l1[l - 1]);
              my_ver.push(s_l[k - 1]);
  
              my_ver.push(s_l1[l]);
  
              my_n.push(s_n1[l]);
              my_n.push(s_n[k - 1]);
              my_n.push(s_n[k]);
  
  
              my_n.push(s_n1[l - 1]);
              my_n.push(s_n[k - 1]);
  
              my_n.push(s_n1[l]);
  
              my_uv.push(s_uv1[l]);
              my_uv.push(s_uv[k - 1]);
              my_uv.push(s_uv[k]);
  
  
              my_uv.push(s_uv1[l - 1]);
              my_uv.push(s_uv[k - 1]);
              my_uv.push(s_uv1[l]);
  
           }
           else {
              my_ver.push(s_l1[l]);
              my_ver.push(s_l[k - 1]);
              my_ver.push(s_l[k]);
  
              my_n.push(s_n1[l]);
              my_n.push(s_n[k - 1]);
              my_n.push(s_n[k]);
  
              my_uv.push(s_uv1[l]);
              my_uv.push(s_uv[k - 1]);
              my_uv.push(s_uv[k]);
  
           }
  
        }
     }
  
     gen_tria_sp(s_l: Array<BABYLON.Vector3>, s_n: Array<BABYLON.Vector3>, s_uv: Array<BABYLON.Vector2>, s_l1: Array<BABYLON.Vector3>, s_n1: Array<BABYLON.Vector3>, s_uv1: Array<BABYLON.Vector2>, my_ver: Array<BABYLON.Vector3>, my_n: Array<BABYLON.Vector3>, my_uv: Array<BABYLON.Vector2>) {
        let c = (s_l.length - 3) / 2 + 1;
        if (s_l.length % 2 == 0) {
           c = (s_l.length - 3) / 2;
        }
  
        for (let i = 0; i < c; i++) {
           if (i != (s_l.length - 3) / 2) {
              my_ver.push(s_l1[i]);
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l[i]);
  
  
              my_ver.push(s_l1[i + 1]);
              my_ver.push(s_l[i + 1]);
  
              my_ver.push(s_l1[i]);
  
              my_n.push(s_n1[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n[i]);
  
  
              my_n.push(s_n1[i + 1]);
              my_n.push(s_n[i + 1]);
  
              my_n.push(s_n1[i]);
  
              my_uv.push(s_uv1[i]);
              my_uv.push(s_uv[i + 1]);
  
              my_uv.push(s_uv[i]);
  
              my_uv.push(s_uv1[i + 1]);
              my_uv.push(s_uv[i + 1]);
  
              my_uv.push(s_uv1[i]);
  
           }
           else {
              my_ver.push(s_l1[i]);
              my_ver.push(s_l[i + 1]);
              my_ver.push(s_l[i]);
  
              my_n.push(s_n1[i]);
              my_n.push(s_n[i + 1]);
              my_n.push(s_n[i]);
  
              my_uv.push(s_uv1[i]);
              my_uv.push(s_uv[i + 1]);
  
              my_uv.push(s_uv[i]);
  
  
           }
  
  
        }
        let k = 0, l = 0;
        for (let i = 0; i < c; i++) {
           k = s_l.length - i - 1;
           l = s_l1.length - i - 1;
           if (i != (s_l.length - 3) / 2) {
              my_ver.push(s_l[k]);
              my_ver.push(s_l[k - 1]);
  
              my_ver.push(s_l1[l]);
  
              my_ver.push(s_l1[l]);
              my_ver.push(s_l[k - 1]);
              my_ver.push(s_l1[l - 1]);
  
  
              my_n.push(s_n[k]);
              my_n.push(s_n[k - 1]);
  
              my_n.push(s_n1[l]);
  
              my_n.push(s_n1[l]);
              my_n.push(s_n[k - 1]);
              my_n.push(s_n1[l - 1]);
  
  
              my_uv.push(s_uv[k]);
              my_uv.push(s_uv[k - 1]);
  
              my_uv.push(s_uv1[l]);
  
              my_uv.push(s_uv1[l]);
              my_uv.push(s_uv[k - 1]);
  
              my_uv.push(s_uv1[l - 1]);
           }
           else {
              my_ver.push(s_l[k]);
              my_ver.push(s_l[k - 1]);
  
              my_ver.push(s_l1[l]);
  
              my_n.push(s_n[k]);
              my_n.push(s_n[k - 1]);
  
              my_n.push(s_n1[l]);
              my_uv.push(s_uv[k]);
              my_uv.push(s_uv[k - 1]);
              my_uv.push(s_uv1[l]);
           }
  
        }
     }


    create_custom3(scene: BABYLON.Scene, mat: BABYLON.Material) {
        var customMesh = new BABYLON.Mesh("custom3", scene);

      var positions = [0, 0, 0, 60, 0, 0, 60, 0, 60, 0, 0, 60];
      var indices = [0, 1, 2, 0, 2, 3];
      var uv = [5, 5, 5, 0, 0, 0, 0, 5, 5, 5, 0, 0];

      var vertexData = new BABYLON.VertexData();

      vertexData.positions = positions;
      vertexData.indices = indices;
      vertexData.uvs = uv;
      vertexData.applyToMesh(customMesh);
      customMesh.material = mat;
      customMesh.position = new BABYLON.Vector3(0, 90, 90);
    }
}